module.exports = __webpack_public_path__ + "img/keyboard_9.a214fab8.png";